import { useBackToSearchButtonStyles } from './back-to-search-button.styles';
import { Button } from '@mui/material';
import { BackToSearch } from '../../../../../../../ui/components/pure/icons/BackToSearch.icon';

export function BackToSearchButton({ onClickBack }: { onClickBack(): void }) {
  const classes = useBackToSearchButtonStyles();
  return (
    <Button className={classes.card} onClick={onClickBack}>
      <BackToSearch />
    </Button>
  );
}
